export const HOLIDAYS = 'holidays'
